import Carousel from 'react-bootstrap/Carousel';
import Sample1 from '../assets/images/sample-1.png'
import Sample2 from '../assets/images/sample-2.png'
import Sample3 from '../assets/images/sample-3.png'

function CorouselExample() {
  return (
    <Carousel>
      <Carousel.Item>
        <img style={{width:"100%"}} src={Sample1} />
        {/* <Carousel.Caption>
          <h3>First slide label</h3>
          <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
        </Carousel.Caption> */}
      </Carousel.Item>
      <Carousel.Item>
      <img style={{width:"100%"}} src={Sample2} />
        {/* <Carousel.Caption>
          <h3>Second slide label</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </Carousel.Caption> */}
      </Carousel.Item>
      <Carousel.Item>
      <img style={{width:"100%"}} src={Sample3} />
        {/* <Carousel.Caption>
          <h3>Third slide label</h3>
          <p>
            Praesent commodo cursus magna, vel scelerisque nisl consectetur.
          </p>
        </Carousel.Caption> */}
      </Carousel.Item>
    </Carousel>
  );
}

export default CorouselExample;